(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3108],{

/***/ 5851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1283);
/* harmony import */ var _components_pages_proyectos_RealestateList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30005);
/* harmony import */ var _components_head_meta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23385);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69898);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var shared_models_const_keywords_const__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6644);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);








var Proyectos = function Proyectos(props) {
  var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  var filters = {
    filters: {
      typeProperty: [{
        id: 14,
        name: "Proyecto",
        slug: "project"
      }]
    },
    refRequest: "project-list-query",
    detailPath: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_1__/* .CPagesPath.es.project_Detail */ .K.es.project_Detail
  };
  var metaData = {
    description: "project",
    title: "projects",
    url: router.asPath,
    keyWords: shared_models_const_keywords_const__WEBPACK_IMPORTED_MODULE_5__/* .CKeyWordsPages.project */ .k.project
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_head_meta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, metaData), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_pages_proyectos_RealestateList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    defaultFilters: filters
  }));
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Proyectos);

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://unete.remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://unete.remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 6644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CKeyWordsPages; }
/* harmony export */ });
var CKeyWordsPages = {
  project: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana",
  join: "conviértete en agente inmobiliario remax, únete a remax república dominicana, agente inmobiliario remax, agencia inmobiliaria, agente inmobiliario, agente Remax",
  page404: "pagina no encontrada",
  home: "inmueble, remax rd, remax república dominicana, alquilar una casa, comprar una casa, comercialización de inmuebles, proyectos en construcción, beneficios de comprar en planos, préstamos hipotecarios, préstamos hipotecarios en república dominicana, franquicia remax, Propiedades destacadas, propiedades de Remax RD, propiedades de remax república dominicana, agente inmobliario, agencia inmobiliaria, propiedades en República Dominicana, alquiler apartamento, bienes raices santo domingo, departamentos en alquiler santo domingo, proyectos de apartamentos en punta cana, alquilar casa, apartamentos en santo domingo este, apartamentos en bavaro, apartamento en venta punta cana, apartamentos en rd, apartamentos en alquiler santo domingo este, proyectos de apartamentos económicos en santo domingo, apartamentos en venta san isidro, apartamentos en venta republica dominicana, apartamentos en alquiler en santo domingo distrito nacional, apartamento en alquiler, casas en alquiler en república dominicana, proyectos de apartamentos en santo domingo distrito nacional, venta de propiedades en republica dominicana, casas rd, venta de casas en santo domingo, apartamento en el millon, alquiler de apartamentos en santo domingo distrito nacional, comprar apartamento en santo domingo, compra de apartamentos en santo domingo, apartamentos en La Romana",
  homeCollections: "Remax collection, propiedades de lujo, propiedades exclusivas, propiedades premium, propiedades collection",
  mortgageLoad: "préstamo hipotecario, Calculadora de prestamos, cuota de préstamos hipotecarios, formulario de prestamos",
  iWantToRent: "casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almacén en alquiler, villas en alquiler, alquiler de aparta estudio, proyectos exclusivos de remax república dominicana",
  iWantToBuy: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana, compra inmobiliaria, adquir propiedad inmobiliaria, inversion inmobiliaria en república dominicana, inversión inmobiliaria"
};

/***/ }),

/***/ 41364:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proyectos",
      function () {
        return __webpack_require__(5851);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3662,2708,1629,8407,2615,6877,4022,70,3843,1664,7918,9043,8543,2960,7956,3828,4864,841,2834,311,9343,4816,6939,8360,7872,6626,4831,6809,3282,2210,8654,9470,1207,5,2888,179], function() { return __webpack_exec__(41364); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);